module.exports = __webpack_public_path__ + "img/icon-warning-regn-2.dfb80b96.svg";